export default "__VITE_ASSET__QfzNxvgb__"